import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="zakat-modal"
export default class extends Controller {
  static targets = [
    "categoryRadio",
    "modalCategory",
    "modalDescription",
    "zakatAmount",
    "formAmount",
    "formCategory",
    "formDescription",
    "amountInput", // For direct amount input (payment page)
    "form", // For form submission
  ];

  connect() {
    this.zakatAmount = "0.00";
    this.calculatorAmountElement = document.querySelector(
      '[data-zakat-calculator-target="zakatDue"]'
    );

    // Category labels mapping
    this.categoryLabels = {
      general: "Where Most Needed",
      food: "Food & Nutrition",
      education: "Education",
      healthcare: "Healthcare",
      emergency: "Emergency Relief",
      widows: "Widow Support",
    };
  }

  zakatAmountTargetChanged() {
    // Update modal content when zakat amount changes
    this.zakatAmount = this.zakatAmountTargets[0].value || "0.00";
    this.updateZakatAmounts();
  }

  updateZakatAmounts() {
    this.zakatAmountTargets.forEach((element) => {
      if (this.hasAmountInputTarget) {
        element.textContent = this.zakatAmount;
      }
      element.value = this.zakatAmount;
    });
  }

  // Called when modal opens to update content with current values
  updateModalContent() {
    if (this.calculatorAmountElement) {
      this.zakatAmount = this.calculatorAmountElement.textContent;
    }
    // Check if we're on payment page with direct input
    else if (this.hasAmountInputTarget) {
      this.zakatAmount = parseFloat(this.amountInputTarget.value || 0).toFixed(
        2
      );
    }

    // Update amount in the modal - target all amount displays
    this.updateZakatAmounts();

    // Also update the form amount field
    if (this.hasFormAmountTarget) {
      this.formAmountTarget.value = this.zakatAmount;
    }

    // Update category and description if a category is selected
    const selectedCategory = this.categoryRadioTargets.find(
      (radio) => radio.checked
    );
    if (selectedCategory) {
      this.modalCategoryTarget.textContent =
        this.categoryLabels[selectedCategory.value] || selectedCategory.value;
      this.modalDescriptionTarget.textContent =
        selectedCategory.dataset.description || "";

      // Update form fields too
      if (this.hasFormCategoryTarget) {
        this.formCategoryTarget.value = selectedCategory.value;
      }
      if (this.hasFormDescriptionTarget) {
        this.formDescriptionTarget.value = selectedCategory.dataset.description;
      }
    }
  }

  // Called when category selection changes
  categoryChanged(event) {
    if (event.target.checked) {
      this.modalCategoryTarget.textContent =
        this.categoryLabels[event.target.value] || event.target.value;
      this.modalDescriptionTarget.textContent =
        event.target.dataset.description || "";

      // Also update the form fields
      if (this.hasFormCategoryTarget) {
        this.formCategoryTarget.value = event.target.value;
      }
      if (this.hasFormDescriptionTarget) {
        this.formDescriptionTarget.value = event.target.dataset.description;
      }
    }
  }

  // Called when the pay button is clicked to proceed to payment
  proceedToPayment() {
    const selectedCategory = this.categoryRadioTargets.find(
      (radio) => radio.checked
    );

    if (!selectedCategory) {
      alert("Please select a category");
      return;
    }

    if (selectedCategory && this.zakatAmount) {
      // Populate the hidden form fields
      if (this.hasFormAmountTarget) {
        this.formAmountTarget.value = this.zakatAmount;
      }
      if (this.hasFormCategoryTarget) {
        this.formCategoryTarget.value = selectedCategory.value;
      }
      if (this.hasFormDescriptionTarget) {
        this.formDescriptionTarget.value = selectedCategory.dataset.description;
      }

      // Submit the form - try different form selectors
      const form =
        this.element.querySelector("#zakat-payment-form") ||
        this.element.querySelector("#zakat-form") ||
        (this.hasFormTarget ? this.formTarget : null);

      if (form) {
        form.submit();
      } else {
        console.error("No form found for submission");
      }
    }
  }
}
